import { Box, Divider, Typography, Link as MuiLink } from "@mui/material";
import { Link } from "react-router-dom";
import { frontendRoutes } from "../../../utility/frontendRoutes";
import { landingColors } from "../landingColors";
import SectionContainer from "./SectionContainer";
import JoinedCounter from "./JoinedCounter";
import LiveCtaBanner from "./LiveCtaBanner";
import MailingListForm from "./MailingListForm";

const GetTheAppSection = () => (
  <SectionContainer id="get-the-app">
    <Box sx={{ maxWidth: { xs: 720, md: 880 }, mx: "auto" }}>
      <Box sx={{ textAlign: "center", mb: 3 }}>
        <Typography
          variant="h3"
          sx={{
            fontWeight: 800,
            color: landingColors.textPrimary,
            fontSize: { xs: 26, md: 36 },
          }}
        >
          Ready to Get Started?
        </Typography>
        <JoinedCounter sx={{ mt: 1 }} />
      </Box>
      <Box
        sx={{
          bgcolor: landingColors.surface,
          boxShadow: landingColors.cardShadow,
          borderRadius: 4,
          p: { xs: 3, md: 5 },
        }}
      >
        <LiveCtaBanner />
        <Divider sx={{ my: { xs: 3, md: 4 } }} />
        <MailingListForm />
      </Box>

      {/* This is the moment a visitor is deciding whether Ngwaahia is for them,
          and the story is the page that answers it. */}
      <Typography
        sx={{
          mt: 3,
          textAlign: "center",
          color: landingColors.textSecondary,
          fontSize: 15,
        }}
      >
        Not sure how it works?{" "}
        <MuiLink
          component={Link}
          to={frontendRoutes.STORY_HOW_TO_USE}
          sx={{
            color: landingColors.primary,
            fontWeight: 700,
            textDecorationColor: "currentColor",
          }}
        >
          Read the story of one order
        </MuiLink>
        , from search to handover.
      </Typography>
    </Box>
  </SectionContainer>
);

export default GetTheAppSection;
